module.exports = __webpack_public_path__ + "static/media/Alert.e60eedf6.svg";